import Stigg from '@stigg/js-client-sdk';
import config from "@/config.js";

const stiggClient = Stigg.initialize({
  apiKey: config.STIGG_API_KEY
});

export const isPayingTeam = async (team_id) => {
  try {
    const activeSubscriptions = await getActiveSubscriptions(team_id);
    return {
      isPaying: activeSubscriptions.some(
        (sub) => !(sub.plan.refId === 'plan-anima-free' || sub.plan.id === 'plan-anima-free')
      ),
      activeSubscriptions,
    };
  } catch (err) {
    console.log(err);
    return {};
  }
};

export const getStigg = () => {
  return stiggClient;
};

export const getCustomerLink = (teamId) => {
  return `${config.STIGG_URL}/customers/${teamId}`;
};

export const getActiveSubscriptions = async (teamId) => {
  try {
    await stiggClient.waitForInitialization();
    stiggClient.setCustomerId(teamId);
    const customer = await stiggClient.getCustomer();
    return customer.getActiveSubscriptions();
  } catch (err) {
    console.log(err);
    return [];
  }
}
